import {
  AURORA,
  MARIADB,
  MS_SQL_SERVER,
  MYSQL,
  ORACLEDB,
  POSTGRESQL,
  SQLITE,
  AIRTABLE,
  APP_WRITE,
  DIRECTUS,
  REST_API,
  SALESFORCE,
  SUPABASE,
  XANO,
  XATA,
  COLLECTION_SNAPSHOT,
} from 'drapcode-constant';
export const dropdownsForSource = [
  { label: 'String', value: 'text' },
  { label: 'Number', value: 'number' },
  { label: 'Boolean', value: 'boolean' },
];

export const dropdownsForSupabase = [
  { label: 'String', value: 'text' },
  { label: 'Number', value: 'number' },
  { label: 'Boolean', value: 'boolean' },
];
export const correctNameFormat = (name) => {
  switch (name) {
    case 'postgresql':
      return 'PostgreSQL';
    case 'mysql':
      return 'MySQL';
    case 'sqlite':
      return 'SQLite';
    case 'ms-sql-server':
      return 'MS SQL Server';
    case 'oracledb':
      return 'OracleDB';
    case 'mariadb':
      return 'MariaDB';
    case 'aurora':
      return 'Aurora';
    default:
      return name;
  }
};
export const COLLECTION_SOURCE_LIST = [
  'DEFAULT',
  COLLECTION_SNAPSHOT,
  'CSV',
  'PROMPT',
  REST_API,
  'JSON',
  APP_WRITE,
  XANO,
  SUPABASE,
  XATA,
  DIRECTUS,
  AIRTABLE,
  SALESFORCE,
  // 'JSON',
  POSTGRESQL,
  MYSQL,
  SQLITE,
  MS_SQL_SERVER,
  ORACLEDB,
  MARIADB,
  AURORA,
];
export const COLLECTION_SOURCE_DATA = {
  DEFAULT: {
    title: 'DrapCode DB',
    description: `Create a collection and it's fields following the default approach.`,
    value: 'DEFAULT',
    backgroundColor: 'bg-info',
    imageUrl: `${process.env.PUBLIC_URL}/favicon.png`,
  },
  PROMPT: {
    title: 'PROMPT',
    description: `Create a collection and it's fields automatically by adding to prompt.`,
    value: 'PROMPT',
    backgroundColor: 'bg-success',
    imageUrl: `${require('../../images/collection/prompt.png')}`,
  },
  CSV: {
    title: 'CSV',
    description: `Create a collection and it's fields automatically by uploading CSV file.`,
    value: 'CSV',
    backgroundColor: 'bg-success',
    imageUrl: `${require('../../images/collection/csv.png')}`,
  },
  REST_API: {
    title: 'REST API',
    description: `Create a collection and it's fields automatically from the REST API response.`,
    value: REST_API,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/rest-api.png')}`,
  },
  JSON: {
    title: 'JSON',
    description: "Create a collection and it's fields automatically by uploading JSON file.",
    value: 'JSON',
    backgroundColor: 'bg-brand-green',
    imageUrl: `${require('../../images/collection/json.png')}`,
  },
  APP_WRITE: {
    title: 'Appwrite',
    description: `You can Create Collection from Appwrite database`,
    value: APP_WRITE,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/appwrite.png')}`,
  },
  XANO: {
    title: 'Xano',
    description: `You can Create Collection from Xano database`,
    value: XANO,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/xano.png')}`,
  },
  SUPABASE: {
    title: 'Supabase',
    description: `You can Create Collection from Supabase database`,
    value: SUPABASE,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/supabase.png')}`,
  },
  XATA: {
    title: 'Xata',
    description: `You can Create Collection from Xata database`,
    value: XATA,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/xata.png')}`,
  },
  DIRECTUS: {
    title: 'Directus',
    description: `You can Create Collection from Directus database`,
    value: DIRECTUS,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/directus.png')}`,
  },
  AIRTABLE: {
    title: 'Airtable',
    description: `You can Create Collection from Airtable database`,
    value: AIRTABLE,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/airtable.png')}`,
  },
  SALESFORCE: {
    title: 'Salesforce',
    description: `You can Create Collection from Salesforce database`,
    value: SALESFORCE,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/salesforce.png')}`,
  },
  POSTGRESQL: {
    title: 'PostgreSQL',
    description: `You can Create Collection from PostgreSQL database`,
    value: POSTGRESQL,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/postgresql.svg')}`,
  },
  MYSQL: {
    title: 'MySQL',
    description: `You can Create Collection from MySQL database`,
    value: MYSQL,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/logo-mysql-26329.png')}`,
  },
  SQLITE: {
    title: 'SQLite',
    description: `You can Create Collection from SQLite database`,
    value: SQLITE,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/application-x-sqlite.374x512.png')}`,
  },
  MS_SQL_SERVER: {
    title: 'MS SQL Server',
    description: `You can Create Collection from MS SQL Server database`,
    value: MS_SQL_SERVER,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/sql-server-icon-png-11352.png')}`,
  },
  ORACLEDB: {
    title: 'OracleDB',
    description: `You can Create Collection from OracleDB database`,
    value: ORACLEDB,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/oracle-db.png')}`,
  },
  MARIADB: {
    title: 'MariaDB',
    description: `You can Create Collection from MariaDB database`,
    value: MARIADB,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/mariadb.512x340.png')}`,
  },
  AURORA: {
    title: 'Aurora',
    description: `You can Create Collection from Aurora database`,
    value: AURORA,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/aurora.png')}`,
  },
  COLLECTION_SNAPSHOT: {
    title: 'Snapshot',
    description: `Create a Collection from Collection Snapshots`,
    value: COLLECTION_SNAPSHOT,
    backgroundColor: 'bg-brand-blue-green',
    imageUrl: `${require('../../images/collection/database.png')}`,
  },
};
